import { InMemoryCache } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import gql from "graphql-tag";
import { graphql, MutationFunc } from "react-apollo";
import { generateApolloLink } from "~/graphql/client";

const NEXUS_API_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.nexusapp.co/nexus/storefront/graphql"
    : "https://api.nexusapp.test/nexus/storefront/graphql";

const nexusClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: generateApolloLink(NEXUS_API_URL)
});

export default nexusClient;

// ====================================================
// Upload type
// ====================================================
export enum StagedUploadType {
  Ticket = "TICKET"
}

// ====================================================
// File to be uploaded
// ====================================================
export interface IStagedUploadInput {
  fileSize: number;
  filename: string;
  mimeType: string;
  type: StagedUploadType;
}

export interface IStagedUploadsCreateInput {
  stagedUploads: IStagedUploadInput[];
}

export interface IStagedUploadsVariables {
  input: IStagedUploadsCreateInput;
}

export interface IStagedUploadsCreateProps {
  uploadFile: MutationFunc<IStagedUploadsVariables>;
}

// ====================================================
// Staged upload parameter
// ====================================================
export interface IStagedUploadParameter {
  __typename?: "StagedUploadParameter";
  name: string;
  value: string;
}

// ====================================================
// Staged upload target information
// ====================================================
export interface IStagedUploadTarget {
  __typename?: "StagedUploadTarget";
  parameters: IStagedUploadParameter[];
  stagedUploadId: string;
  url: string;
}
export interface IStagedUploadsCreatePayload {
  __typename?: "StagedUploadsCreatePayload";
  stagedTargets: IStagedUploadTarget[];
}

export interface IStagedUploadsCreateResponse {
  data: {
    stagedUploadsCreate: IStagedUploadsCreatePayload;
  };
}

export const STAGED_UPLOADS_CREATE_MUTATION = gql`
  mutation StagedUploadsCreate($input: StagedUploadsCreateInput!) {
    stagedUploadsCreate(input: $input) {
      stagedTargets {
        stagedUploadId
        url
        parameters {
          name
          value
        }
      }
    }
  }
`;

export const withStagedUploadsCreateMutation = graphql(
  STAGED_UPLOADS_CREATE_MUTATION,
  {
    name: "uploadFile"
  }
);



// WEBPACK FOOTER //
// ./src/graphql/mutations/trengoTicket/uploadFile.ts